/**
 * 不出错的播放 audio;
 * play() 可能返回的不是 promise;
 */
export function safePlayAudio(audio, errorCallback) {
    try {
        var playPromise = audio.play();
        // In browsers that don’t yet support this functionality,
        // playPromise won’t be defined.
        if (playPromise !== undefined) {
            playPromise.catch(errorCallback);
        }
    }
    catch (err) {
        errorCallback(err);
    }
}
// https://easings.net/
function easeIn(x) {
    return x * x;
}
function easeOut(x) {
    return 1 - Math.pow(1 - x, 2);
}
var FadeUtils = /** @class */ (function () {
    function FadeUtils() {
        this.timer = null;
        this.isEasing = false;
    }
    FadeUtils.prototype.fadeIn = function (opts) {
        var _this = this;
        if (this.isEasing && this.timer) {
            clearInterval(this.timer);
        }
        var audio = opts.audio, targetVolume = opts.targetVolume, duration = opts.duration, onStart = opts.onStart;
        var startValue = this.isEasing ? audio.volume : 0;
        return this.easing({
            startValue: startValue,
            endValue: targetVolume,
            duration: duration,
            ease: easeIn,
            onStart: function () {
                _this.isEasing = true;
                onStart === null || onStart === void 0 ? void 0 : onStart();
            },
            onUpdate: function (val) {
                audio.volume = val;
            },
            onEnd: function () {
                audio.volume = targetVolume;
                _this.isEasing = false;
            },
        });
    };
    FadeUtils.prototype.fadeOut = function (opts) {
        var _this = this;
        if (this.isEasing && this.timer) {
            clearInterval(this.timer);
        }
        var audio = opts.audio, duration = opts.duration, onEnd = opts.onEnd;
        return this.easing({
            startValue: audio.volume,
            endValue: 0,
            duration: duration,
            ease: easeOut,
            onStart: function () {
                _this.isEasing = true;
            },
            onUpdate: function (val) {
                audio.volume = val;
            },
            onEnd: function () {
                audio.volume = 0;
                _this.isEasing = false;
                onEnd === null || onEnd === void 0 ? void 0 : onEnd();
            },
        });
    };
    FadeUtils.prototype.easing = function (opts) {
        var _this = this;
        var startValue = opts.startValue, endValue = opts.endValue, duration = opts.duration, ease = opts.ease, onStart = opts.onStart, onUpdate = opts.onUpdate, onEnd = opts.onEnd;
        var d = duration * Math.abs(endValue - startValue);
        return new Promise(function (r) {
            var startTime = Date.now();
            var deltaTime = 0;
            onStart === null || onStart === void 0 ? void 0 : onStart();
            _this.timer = setInterval(function () {
                if (deltaTime >= d) {
                    if (_this.timer) {
                        clearInterval(_this.timer);
                    }
                    // onUpdate(endValue)
                    onEnd === null || onEnd === void 0 ? void 0 : onEnd();
                    r();
                }
                else {
                    var t = deltaTime / d;
                    var easingValue = ease(t);
                    var value = startValue + (endValue - startValue) * easingValue;
                    onUpdate(value);
                    deltaTime = Date.now() - startTime;
                }
            }, 10);
        });
    };
    return FadeUtils;
}());
export { FadeUtils };
